import Vue from 'vue'
import appConfig from '@/config.js'
import store from '@/store'

const ApiService = {
  query(resource, params) {
    console.log('============ API CALL')
    console.log('GET ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.get(appConfig.api.baseUrl + resource, params)
  },

  get(resource, id = '', params) {
    console.log('============ API CALL')
    console.log('GET ' + `${appConfig.api.baseUrl}${resource}/${id}`)
    console.log(params)
    console.log('============')
    return Vue.http.get(`${appConfig.api.baseUrl}${resource}/${id}`, params)
  },

  post(resource, params) {
    console.log('============ API CALL')
    console.log('POST ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.post(`${appConfig.api.baseUrl}${resource}`, params)
  },

  update(resource, id, params) {
    console.log('============ API CALL')
    console.log('PATCH ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.patch(`${appConfig.api.baseUrl}${resource}/${id}`, params)
  },

  put(resource, params) {
    console.log('============ API CALL')
    console.log('PUT ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.put(`${appConfig.api.baseUrl}${resource}`, params)
  },

  patch(resource, params) {
    console.log('============ API CALL')
    console.log('PATCH ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.patch(`${appConfig.api.baseUrl}${resource}`, params)
  },

  delete(resource, params) {
    console.log('============ API CALL')
    console.log('DELETE ' + appConfig.api.baseUrl + resource)
    console.log('============')
    return Vue.http.delete(appConfig.api.baseUrl + resource, params)
  }
}

export default ApiService

export const ShippingsService = {
  query(type, params) {
    return ApiService
      .query(
        'users/' + store.state.auth.uid + '/shippings' + (type === 'feed' ? '/feed' : ''),
        { params }
      )
  },
  get(id, params) {
    return ApiService.get('users/' + store.state.auth.uid + '/shippings', id, { params })
  },
  create(params) {
    return ApiService.post('users/' + store.state.auth.uid + '/shippings', { params })
  },
  update(id, params) {
    return ApiService.update('users/' + store.state.auth.uid + '/shippings', id, { shipping: params })
  },
  destroy(id) {
    return ApiService.delete(`users/${store.state.auth.uid}/shippings/${id}`)
  }
}

export const ShippingsGuestService = {
  get(id, params) {
    return ApiService.get('guest/shippings', id, { params })
  },
  update(id, params) {
    return ApiService.update('guest/shippings', id, { shipping: params })
  }
}

export const MeliService = {
  query(criteria) {
    const params = criteria.params
    console.log(params)
    return ApiService
      .query(
        'platforms/meli/shippings',
        { params }
      )
  }
}

export const PaymentMethodsService = {
  query(type, params) {
    return ApiService
      .query(
        `users/${store.state.auth.uid}/payment-methods`,
        { params }
      )
  },
  create(params) {
    return ApiService.post(`users/${store.state.auth.uid}/payment-methods`, params)
  },
  update(id, params) {
    delete params.id
    return ApiService.update(`users/${store.state.auth.uid}/payment-methods`, id, params)
  },
  destroy(id) {
    return ApiService.delete(`users/${store.state.auth.uid}/payment-methods/${id}`)
  }
}

export const UsersService = {
  get(params) {
    return ApiService.get('users', store.state.auth.uid, params)
  },
  update(params) {
    return ApiService.update('users', store.state.auth.uid, params)
  },
  destroy() {
    return ApiService.delete('users', store.state.auth.uid)
  },
  changePassword(params) {
    return ApiService.put(`users/${store.state.auth.uid}/change-password`, params)
  }
}

export const AddressesService = {
  query(type, params) {
    return ApiService
      .query(
        'users/' + store.state.auth.uid + '/addresses',
        { params }
      )
  },
  create(params) {
    return ApiService.post(`users/${store.state.auth.uid}/addresses`, params)
  },
  update(id, params) {
    return ApiService.update('users/' + store.state.auth.uid + '/addresses', id, params)
  },
  destroy(id) {
    return ApiService.delete(`users/${store.state.auth.uid}/addresses/${id}`)
  }
}

export const PlatformsService = {
  query() {
    return ApiService
      .query(
        `users/${store.state.auth.uid}/platforms`
      )
  },
  destroy(slug) {
    return ApiService.delete(`platforms/${slug}/authorize`)
  },
  destroyApplication(id) {
    return ApiService.delete(`applications/${id}`)
  },
  get(slug, code, shop = null) {
    if (shop) { return ApiService.get(`platforms/${slug}/authorize/${code}?shop=${shop}`) }
    return ApiService.get(`platforms/${slug}/authorize/${code}`)
  }
}

export const FaqsService = {
  query(type, params) {
    return Vue.http
      .get(
        appConfig.helpdocs.baseUrl + 'posts/?filter[taxonomy]=category&filter[term]=' + appConfig.helpdocs.category + '&filter[tag]=' + appConfig.helpdocs.tag + '&per_page=100&key=' + appConfig.helpdocs.api_key,
        { params }
      )
  },
  get(id, params) {
    console.log(id)
    return Vue.http.get(appConfig.helpdocs.baseUrl + 'posts/' + id, id, { params })
  }
}

export const CommentsService = {
  get(id) {
    if (typeof id !== 'string') {
      throw new Error('[MVA] CommentsService.get() shipping id required to fetch comments')
    }
    return ApiService.get('users/' + Vue.$store.getters.uid + '/shippings', `${id}/comments`)
  },

  post(id, payload) {
    return ApiService.post(
      `users/${Vue.$store.getters.uid}/shippings/${id}/comments`, { comment: { body: payload } })
  },

  destroy(id, commentId) {
    return ApiService
      .delete(`users/${Vue.$store.getters.uid}/shippings/${id}/comments/${commentId}`)
  }
}

export const FavoriteService = {
  add(id) {
    return ApiService.post(`shippings/${id}/favorite`)
  },
  remove(id) {
    return ApiService.delete(`shippings/${id}/favorite`)
  }
}
